import { FC } from 'react'

import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsLoadingStateLabel/CryptoRewardsLoadingStateLabel.styl'

export const CryptoRewardsLoadingStateLabel: FC = ({ children }) => (
  <h5 className={ styles.label }>{ children }</h5>
)
